export default {
  background: "#EAF0F2",
  primary: {
    lighter: "#C2E6E95A",
    light: "#C2E6E9",
    dark: "#66C2C9",
    darker: "#009AA7",
  },
  secondary: "#126BFA",
  tertiary: {
    light: "#3E606E",
    dark: "#193D4C",
  },
  blueButton: "#1FB1D5",
  checkBoxBlue: "#25AFD9",
  accent: "#731CD9",
  accentLight: "#AD89D6",
  error: "#D81111",
  muted: "#93A5B7",
  text: {
    dark: "#1A2938",
    light: "#4D657E",
    url: "#439CB2",
    darker: "#1A3D4C"
  },
  formLabelText: "#727F85",
  buttonBarShadow: "#E8EBED",
  link: "#4D657E",
  inactive: "#CAD3DD",
  inactiveButton: "rgba(19, 1, 1, 0.3)",
  activeSegment: "#EAF2D8",
  inactiveSegment: "#F9FAFB",
  tagGreen: {
    default: "#D0E1AA",
    dark: "#088B29",
  },
  tagBlue: "#97DEF3",
  tagRed: "#F6CCDF",
  submitGreen: {
    default: "#22D081",
    dark: "#116840",
    light: "#E8FAF2",
  },
  paginationSelect: "#D3E8ED",
  cancelRed: {
    default: "#FF5772",
    dark: "#7E0014",
    light: "#FFCDD5",
  },
  lightInput: {
    deafult: "#E8E8E8", 
  },
  greyInput: "#D7E0E3",
  blueInputHover: "#DCF4FB",

  dataColors: {
    l0: "#EAF0F2", // Background color to represent missing data
    l1: "#C2E6E9",
    l2: "#a8e0e5",
    l3: "#91dbe1",
    l4: "#75d5dd",
    l5: "#51cfda",
    l6: "#02c9d6",
    l7: "#07AFBA",
  },
  redDataColors: {
    l0: "#fef0f0", // Background color to represent missing data
    l1: "#fde8e8",
    l2: "#fbbcbc",
    l3: "#f99a9a",
    l4: "#f66b6b",
    l5: "#f33c3c",
    l6: "#ff0000",
    l7: "#cc0000",
  },
  distinctDataColors: {
    red: "#FF5B63",
    green: "#19A979",
    blue: "#5899DA",
    orange: "#F58231",
    purple: "#945ECF",
    magenta: "#BF399E",
    lime: "#CFD95A",
    pink: "#BF399E",
    teal: "#C8FAF1",
    yellow: "#F7F1A8",
    lavender: "#BDABDA",
    brown: "#AB8B7B",
    beige: "#BDD081",
    maroon: "#924A5B",
    mint: "#D3F7E0",
    olive: "#8E9C61",
    apricot: "#EE6868",
    cyan: "#13A4B4",
    navy: "#2F6497",
    grey: "#6C8893",
    gold: "#E7D27C",
  },
};

// Raquel Original
// dataColors: {
//   l0: "#EAF0F2", // Background color to represent missing data
//     l1: "#C2E6E9",
//     l2: "#66C2C9",
//     l3: "#41ACDB",
//     l4: "#126BFA",
//     l5: "#134DAC",
//     l6: "#1A2938",
// },

// Pink Original Certainly Not
// l1: "#fde8ff",
//   l2: "#fbcaf7",
//   l3: "#fbaaeb",
//   l4: "#fc87da",
//   l5: "#fe5cc5",
//   l6: "#ff08ac",
